export default {
  defaultImageURI: 'https://images.pexels.com/photos/57553/pexels-photo-57553.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260'
};